module.exports = __webpack_public_path__ + "static/media/109.9d132df8.jpg";